/* eslint-disable import/prefer-default-export */
import {
  JOB_STATUS,
  STATUS_FILTER,
} from '@/components/Company/importer/constants';

const JOBS = [
  {
    id: 1,
    entityType: 'properties',
    name: 'Vivareal',
    origin: { type: 'file', label: 'import.xml' },
    status: JOB_STATUS.IN_PROGRESS,
    elements: ['properties', 'contacts', 'developments'],
    author: { name: 'Carlos Díaz', date: '2026-06-17T13:33:00Z' },
    records: { total: 137, processed: 137, errors: 0 },
    results: null,
    validation: null,
  },
  {
    id: 2,
    entityType: 'properties',
    name: 'Link',
    origin: {
      type: 'link',
      label: 'https://www.tuinmobiliaria.com/feeds/properties_feed.xml',
    },
    status: JOB_STATUS.DONE,
    elements: ['properties'],
    author: { name: 'Carlos Díaz', date: '2026-06-17T13:33:00Z' },
    records: { total: 137, processed: 137, errors: 0 },
    results: {
      entityType: 'properties',
      total: 137,
      processed: 137,
      imported: null,
      created: null,
      updated: null,
      skipped: null,
      errors: 0,
      alerts: 0,
      skippedByReason: null,
    },
    validation: null,
  },
  {
    id: 3,
    entityType: 'contacts',
    name: 'Contacts file',
    origin: { type: 'file', label: 'contacts.csv' },
    status: JOB_STATUS.DONE,
    elements: ['contacts'],
    author: { name: 'Carlos Díaz', date: '2026-06-17T13:33:00Z' },
    records: { total: 20, processed: 20, errors: 0 },
    results: {
      entityType: 'contacts',
      total: 20,
      processed: 20,
      imported: 0,
      created: 0,
      updated: 0,
      skipped: 20,
      errors: 0,
      alerts: 0,
      skippedByReason: {
        dbDuplicate: 20,
        fileDuplicate: 0,
        missingName: 0,
        missingContactInfo: 0,
      },
    },
    validation: null,
  },
  {
    id: 4,
    entityType: 'properties',
    name: 'Casa Mineira',
    origin: { type: 'api', label: '' },
    status: JOB_STATUS.ERROR,
    elements: ['properties', 'contacts'],
    author: { name: 'Carlos Díaz', date: '2026-06-17T13:33:00Z' },
    records: { total: 137, processed: 132, errors: 5 },
    results: {
      entityType: 'properties',
      total: 137,
      processed: 132,
      imported: null,
      created: null,
      updated: null,
      skipped: null,
      errors: 5,
      alerts: 0,
      skippedByReason: null,
    },
    validation: null,
  },
];

const COUNTS = { done: 3, in_progress: 1, error: 2 };

export const getMockJobsResponse = ({
  statusFilter = STATUS_FILTER.ALL,
} = {}) => {
  const jobs =
    statusFilter === STATUS_FILTER.ALL
      ? JOBS
      : JOBS.filter((job) => job.status === statusFilter);

  return {
    counts: COUNTS,
    jobs,
    pagination: { total_items: jobs.length, page_size: 10, page: 1 },
  };
};
